<template>
  <div ref="editmodal">
    <v-row justify="center">
      <v-container fluid>
        <v-dialog v-model="show" persistent max-width="600px">
          <custom-modal
            title="Edit Bed Type"
            @onSubmit="SaveCategory"
            @onClose="show = false"
            :isLoading="isLoading"
          >
            <ValidationObserver ref="observer" v-slot="{ validate, reset }">
              <v-row>
         
                <v-col cols="12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Name"
                    vid="name"
                    rules="required"
                  >
                    <v-text-field
                      :error-messages="errors"
                      required
                      v-model="bedtype.name"
                      label="Name"
                      auto-grow
                      outlined
                      hide-details="auto"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" lg="6" md="6">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Code"
                    vid="code"
                    rules="required"
                  >
                    <v-text-field
                      :error-messages="errors"
                      required
                      v-model="bedtype.code"
                      label="Code"
                      auto-grow
                      outlined
                      hide-details="auto"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </ValidationObserver>
          </custom-modal>
        </v-dialog>
      </v-container>
    </v-row>
  </div>
</template>
<script>
import CustomModal from "@/components/base/CustomModal";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
export default {
  data: () => ({
    dialog: false,

    isLoading: false,
  }),

  name: " ",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    bedtype: {
      type: Object,
      default: {},
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.bedtype);
          this.visible = value;
        }
      },
    },
  },
  methods: {
    async SaveCategory() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.EditBedType();
      }
    },

    EditBedType() {
      
      this.isLoading = true;
      const credential = this.bedtype;
      this.$store
        .dispatch("bedtype/EditBedtypes", new Bedtype().SetData(credential))
        .then((res) => {
          this.succeeed = true;

          this.$emit("afterSave");

          this.$toast.success("Bed Type edited  successfully");

          this.show = false;
          this.visible = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$refs.observer.setErrors(err.data.error);
          this.$toast.error("Bed Type edited failed");
        });
    },
  },
};
export class Bedtype {
  constructor() {
    this.id = null;
    this.name = "";
    this.code = "";
    this.is_active = false;
  }

  SetData(u) {
    
    const bedtype = new Object();
    bedtype.id = u.id ? u.id : "";
    bedtype.name = u.name ? u.name : "";
    bedtype.code = u.code ? u.code : "";
    return bedtype;
  }
}
</script>

<style></style>
